import React from "react";

import type {TreeRow} from "./positionTree";

// The connecting lines to the left of a position in the persona menus.
//
// CSS borders on full-height columns, not box-drawing characters. A "│" is only font-height inside
// a menu row that is half as tall again, so a column of them reads as a dashed line with gaps at
// every row boundary. Borders that span the row join seamlessly with the row above and below.
//
// Ported from t6's CustomGridTreeDataGroupingCell, deliberately keeping its measurements so the two
// products' trees look like the same tree.
export const GUIDE_LINE = "1px solid #B0B4BA";
export const GUIDE_CELL = 22;

// A menu row's own vertical padding, which the guides have to reach past. The lines live inside the
// row's content box, so without this they stop short at each end and the column breaks exactly where
// it is meant to join. Applied as explicit padding on the row too, so the two always agree.
export const ROW_PADDING = 6;

export default function PositionTreeGuides({row}: {row: TreeRow}) {
    if (row.depth === 0) return null;

    const span = {top: -ROW_PADDING, bottom: -ROW_PADDING};

    return (
        <>
            {row.guides.map((carriesOn, index) => (
                <span key={`guide-${index}`}
                      style={{position: "relative", flex: "0 0 auto", width: GUIDE_CELL,
                              alignSelf: "stretch"}}>
                    {carriesOn ? (
                        <span style={{position: "absolute", left: GUIDE_CELL / 2, ...span,
                                      borderLeft: GUIDE_LINE}}/>
                    ) : null}
                </span>
            ))}

            {/* The elbow into this row: a vertical that stops halfway when this is the last child,
                and a horizontal stub into the name. */}
            <span style={{position: "relative", flex: "0 0 auto", width: GUIDE_CELL,
                          alignSelf: "stretch"}}>
                <span style={{position: "absolute", left: GUIDE_CELL / 2, top: -ROW_PADDING,
                              height: row.isLast ? `calc(50% + ${ROW_PADDING}px)` : `calc(100% + ${ROW_PADDING * 2}px)`,
                              borderLeft: GUIDE_LINE}}/>
                <span style={{position: "absolute", left: GUIDE_CELL / 2, top: "50%",
                              width: GUIDE_CELL / 2, borderTop: GUIDE_LINE}}/>
            </span>
        </>
    );
}
